// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"774":"c8c8a9c1","800":"35f6927e"}[chunkId] + ".css";
};